"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertToNumber = function (input, defaultValue) {
    if (!input)
        return defaultValue;
    var number = +input;
    if (isNaN(number))
        return defaultValue;
    return number;
};
exports.default = convertToNumber;
